import Datalist from './Datalist';

export default Datalist;
